import {clsx} from 'clsx';
import {useCallback} from 'react';
import {formatIsoStringToJp} from '../lib/format-iso-string-to-jp';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {shownNumber} from '../press-release-carousel/const';
import styles from './slide.module.css';

export type StoryProps = {
  id: number;
  title: string;
  hash: string;
  smallThumbnailUrl: string | null;
  postedAt: string;
};

type Props = {
  readonly currentIndex: number;
  readonly slideNumber: number;
} & Omit<StoryProps, 'id'>;

export function Slide({
  title,
  hash,
  smallThumbnailUrl,
  postedAt,
  currentIndex,
  slideNumber,
}: Props) {
  // 表示されないスライドは徐々に薄くする
  const gradient = useCallback(() => {
    // 表示されていない右のスライド
    if (
      isContainerQueryAvailable() &&
      slideNumber / shownNumber >= currentIndex
    ) {
      return styles.gradientRightToLeftCQ;
    }

    if (
      !isContainerQueryAvailable() &&
      slideNumber / shownNumber >= currentIndex
    ) {
      return styles.gradientRightToLeftFallback;
    }

    // 表示されていない左のスライド
    if (
      isContainerQueryAvailable() &&
      slideNumber / shownNumber < currentIndex - 1
    ) {
      return styles.gradientLeftToRightCQ;
    }

    if (
      isContainerQueryAvailable() &&
      slideNumber / shownNumber < currentIndex - 1
    ) {
      return styles.gradientLeftToRightFallback;
    }

    return undefined;
  }, [currentIndex, slideNumber]);

  return (
    <li className={clsx(styles.slide, gradient())}>
      <article className={styles.article}>
        <a href={`/story/detail/${hash}`} className={styles.imgWrapper}>
          <img
            src={
              smallThumbnailUrl !== null && smallThumbnailUrl.length > 0
                ? smallThumbnailUrl
                : '/common/v3/blank/223x148.png'
            }
            width={262}
            height={148}
            alt=''
          />
        </a>

        <div
          className={clsx(
            styles.description,
            isContainerQueryAvailable()
              ? styles.descriptionCQ
              : styles.descriptionFallback,
          )}
        >
          <a href={`/story/detail/${hash}`}>
            <p className={styles.title}>{title}</p>
          </a>

          <time dateTime={postedAt} className={styles.date}>
            {formatIsoStringToJp(postedAt)}
          </time>
        </div>
      </article>
    </li>
  );
}
